import { axios } from '@/utils/request'

const api = {
  Pre: '/teacher.php/Plan/pre',
  FeijiaoPlan: '/teacher.php/Plan/feijiaoplan',
  OumeiPlan: '/teacher.php/Plan/oumeiplan',
  ZuowenPlan: '/teacher.php/Plan/zuowenplan',
  ChangePlan: '/teacher.php/Plan/changeplan',
}

// 预加载
export function getPre () {
  return axios({
    url: api.Pre,
    method: 'get'
  })
}

export function feijiaoPlan (parameter) {
  return axios({
    url: api.FeijiaoPlan,
    method: 'get',
    params: parameter
  })
}

export function oumeiPlan (parameter) {
  return axios({
    url: api.OumeiPlan,
    method: 'get',
    params: parameter
  })
}

export function zuowenPlan (parameter) {
  return axios({
    url: api.ZuowenPlan,
    method: 'get',
    params: parameter
  })
}

export function changePlan (parameter) {
  return axios({
    url: api.ChangePlan,
    method: 'post',
    data: parameter
  })
}
